import { Mail, Phone } from "lucide-react";

import { Button } from "@/components/ui/button";
import { CalculatorButton } from "./CalculatorButton";
import {
  EMAIL_ADDRESS,
  EMAIL_HREF,
  PHONE_DISPLAY,
  PHONE_HREF,
} from "@/lib/landingLinks";

/**
 * The closing ask, on a deep teal surface so it reads as the end of the page.
 *
 * Just the action - the contact details live in the footer, once.
 *
 * `secondary` is "call" or "email", so each service ends on whichever next
 * step actually suits it.
 */
export const FinalCta = ({
  heading,
  text,
  ctaLabel,
  service,
  slug,
  secondary = "call",
}) => (
  <section data-testid={`${slug}-final-cta`} className="-mb-20 bg-[color:var(--tt-teal-deep)]">
    <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <h2 className="max-w-[28ch] text-[27px] font-bold leading-[1.15] tracking-[-0.015em] text-white sm:text-[34px]">
        {heading}
      </h2>
      <p className="mt-4 max-w-[54ch] text-[15px] leading-relaxed text-white/80 sm:text-base">
        {text}
      </p>

      <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
        <CalculatorButton
          service={service}
          testId={`${slug}-final-cta-button`}
          className="bg-white text-[color:var(--tt-teal-deep)] hover:bg-white/90"
        >
          {ctaLabel}
        </CalculatorButton>

        {secondary === "email" ? (
          <Button
            asChild
            size="lg"
            variant="outline"
            data-testid={`${slug}-final-email`}
            className="h-12 min-h-[44px] border-white/40 bg-transparent px-5 text-[15px] font-semibold text-white hover:bg-white/10 hover:text-white"
          >
            <a href={EMAIL_HREF}>
              <Mail className="mr-2 h-4 w-4" aria-hidden="true" />
              {EMAIL_ADDRESS}
            </a>
          </Button>
        ) : (
          <Button
            asChild
            size="lg"
            variant="outline"
            data-testid={`${slug}-final-call`}
            className="h-12 min-h-[44px] border-white/40 bg-transparent px-5 text-[15px] font-semibold text-white hover:bg-white/10 hover:text-white"
          >
            <a href={PHONE_HREF}>
              <Phone className="mr-2 h-4 w-4" aria-hidden="true" />
              {PHONE_DISPLAY}
            </a>
          </Button>
        )}
      </div>
    </div>
  </section>
);
